import * as React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import "./filterMenu.scss"

const Filtermenu = () => {
  const data = useStaticQuery(graphql`
    query postQuery {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
      allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
        nodes {
          fields {
            slug
          }
          frontmatter {
            postType
          }
        }
      }
    }
  `)

  function filter(postType) {
    const allArticleLinks = document.getElementsByClassName("articleLink")
    // console.log(allArticleLinks)
    Array.from(allArticleLinks).forEach(function (article) {
      if (article.getAttribute("posttype") !== postType) {
        if (
          article.parentNode.parentNode.getAttribute("style") ===
            "display:inherit" ||
          article.parentNode.parentNode.getAttribute("style") ===
            "display: inherit;"
        ) {
          // article.setAttribute("style", "display:none")
          article.parentNode.parentNode.setAttribute("style", "display:none")
          disableLinks(postType)
        } else if (
          article.parentNode.parentNode.getAttribute("style") === "display:none"
        ) {
          // article.setAttribute("style", "display:inline")
          // console.log("hello")
          article.parentNode.parentNode.setAttribute("style", "display:inherit")
          enableLinks(postType)
        }
      }
    })
  }

  const posts = data.allMarkdownRemark.nodes
  const postTypeMap = new Map()

  posts.map(post => {
    const postType = post.frontmatter.postType

    if (postTypeMap.has(postType)) {
      postTypeMap.set(postType, postTypeMap.get(postType) + 1)
    } else {
      postTypeMap.set(postType, 1)
    }
    return 0
  })

  const postTypeArray = Array.from(postTypeMap)

  function disableLinks(postType) {
    const links = document.getElementsByClassName("filterMenuItem")
    Array.from(links).forEach(link => {
      if (link.children[0].getAttribute("posttypeattribute") !== postType) {
        link.classList.add("isDisabled")
      }
    })
  }

  function enableLinks(postType) {
    const links = document.getElementsByClassName("filterMenuItem")
    Array.from(links).forEach(link => {
      if (link.children[0].getAttribute("posttypeattribute") !== postType) {
        link.classList.remove("isDisabled")
      }
    })
  }

  return (
    <ol className="filterMenu">
      {postTypeArray.map(outer => {
        let postType = outer[0]
        const amount = outer[1]
        if (postType == null) {
          postType = "Undefined Post"
        }
        return (
          <li className="filterMenuItem">
            <Link
              to="#"
              onClick={function () {
                filter(outer[0])
              }}
              postTypeAttribute={postType}
            >
              <small>
                {postType}: {amount}
              </small>
            </Link>
          </li>
        )
      })}
    </ol>
  )
}

export default Filtermenu
